export default __webpack_public_path__ + "static/media/Dis_PrintWHT.a735aa37.svg";